"use client";

import { ReactNode } from "react";

import { UserIcon } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

function ClientInfoLayout({
  header,
  children,
}: {
  header?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <Card>
      <CardHeader className={cn(header ? "space-y-4" : undefined)}>
        <CardTitle className="flex items-center gap-2">
          <UserIcon className="text-primary size-5" />
          Informations Client
        </CardTitle>
        {header ? <div className="w-full">{header}</div> : null}
      </CardHeader>
      {children ? <CardContent>{children}</CardContent> : null}
    </Card>
  );
}

export { ClientInfoLayout };
